/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { SigintSensor, SigintSensor$inboundSchema } from "./sigintsensor.js";

export type ListSigintSensorsResult = {
  /**
   * Final returned sensor ID when another page exists
   */
  nextCursor?: string | undefined;
  /**
   * Sensors in this page
   */
  sensors: Array<SigintSensor>;
};

/** @internal */
export const ListSigintSensorsResult$inboundSchema: z.ZodMiniType<
  ListSigintSensorsResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    sensors: z.array(SigintSensor$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listSigintSensorsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSigintSensorsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSigintSensorsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSigintSensorsResult' from JSON`,
  );
}
